import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {SessionActions} from "../../../shared/actions";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {AdministrationUnit} from "../../../shared/view-model/organization/administration-unit.type";
import {AdministrationUnitService} from "../../services/administration_unit_service/administration-unit.service";

@Component({
  selector: 'vb-administration-units-list',
  templateUrl: './administration-units-list.component.html',
  styleUrls: ['./administration-units-list.component.css']
})
export class AdministrationUnitsListComponent extends AbstractListView implements OnInit, OnChanges {

  @ViewChild('adminUnitsTable')
  adminUnitsTable: DatatableComponent;

  @ViewChild('adminUnitModal')
  adminUnitModal: GenericModalComponent;

  @ViewChild('addressTemplate')
  addressTemplate: TemplateRef<any>;

  @Input()
  adminUnitsList: AdministrationUnit[] = [];

  currentAdminUnitItem: AdministrationUnit;
  currentAdminUnitControl: FormGroup;

  selected: string[] = [];

  @Output()
  selectedChange: EventEmitter<string[]> = new EventEmitter();

  @ViewChild('adminUnitForm')
  adminUnitForm; //TODO: Add Type

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder,
              private adminUnitService: AdministrationUnitService) {
    super(sessionActions, cd);
  }

  ngOnInit() {

    super.ngOnInit();

    //TODO: Add columns
    this.columns = [
      {prop: 'label', name: 'Name', flexGrow: 2},
      {prop: 'identities.0.ean', name: 'EAN', flexGrow: 1},
    ];

    this.searchTerm = new FormControl();

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.adminUnitsList) {
      this.rows = this.adminUnitsList;
    }
  }

  onEditAdminUnitClicked(adminUnit: AdministrationUnit) {
    //TODO: Add Admin Unit Form
    //this.currentadminUnitControl = ClientFormComponent.initControl(this.fb);
    this.adminUnitModal.show();
    this.cd.detectChanges();
  }

  onSaveAdminUnitClicked() {
    //TODO: Implement
  }

  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.adminUnitsList;
    } else {
      if (this.adminUnitsList) {
        this.rows = this.adminUnitsList.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

  onCellUpdate(row, res, index) {
  }

  onSelectedChanged(selected: string[]) {
    this.selected = [...selected];
    this.selectedChange.emit(this.selected);
  }

}



// WEBPACK FOOTER //
// ./src/app/organization/administration_unit/administration-units-list/administration-units-list.component.ts